document.addEventListener('DOMContentLoaded', function() {

  console.log('custom.js');
  
  if (document.querySelectorAll('body.template-product').length > 0){
    if (hide_salespoint_arr.length > 0){
      
    hide_salespoint_arr.forEach(function(item) {
      if (meta.product.type == item){
          const elems = document.querySelectorAll('[data-hide-for-pt="' + item + '"]');
          elems.forEach(elem => {
            elem.style.display = 'none';
          });
       }
    });
      
    }
  }


});



function sendCartData(eventType) {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const productData = JSON.parse(document.getElementById('cart-product-data').textContent);
      const items = cart.items.map(item => {
        console.log(item);
        const productInfo = productData.products.find(p => p.variant_id === item.variant_id);
        if (productInfo) {
          return {
            item_variant_id: productInfo.variant_id,
            item_name: productInfo.item_name,
            item_id: productInfo.item_id,
            // item_category: productInfo.item_category,
            // item_category2: productInfo.item_category2,
            // discount_percentage: productInfo.discount_percentage,
            // color: productInfo.color,
            // size: productInfo.size,
            // stock_status: productInfo.stock_status,
            // price: productInfo.price,
            // currency: productInfo.currency,
            // quantity: productInfo.quantity
          };
        } else {
          return null;
        }
      }).filter(item => item !== null);
  
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: eventType,
        ecommerce: {
          items: items
        }
      });
    })
    .catch(error => {
      console.error('Error fetching cart data:', error);
    });
  }

  window.upcartOnCartOpened = () => {
    sendCartData("view_cart");
  }

  window.upcartOnAddUpsell = (id) => {
    console.log(id);
    handleAddToCartClick();
  }

  window.upcartOnAddToCart = (id, quality, item) => {
    sendAddCartData(item.variant_id, "add_to_cart");
  }

  function sendAddCartData(id, eventType) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const productData = JSON.parse(document.getElementById('cart-product-data').textContent);
        const items = cart.items.map(item => {
          const productInfo = productData.products.find(p => p.variant_id === item.variant_id);
          if (item.variant_id == id) {
            return {
              item_variant_id: item.variant_id,
              item_name: productInfo.item_name,
              item_id: productInfo.item_id,
              // item_category: productInfo.item_category,
              // item_category2: productInfo.item_category2,
              // discount_percentage: productInfo.discount_percentage,
              // color: productInfo.color,
              // size: productInfo.size,
              // stock_status: productInfo.stock_status,
              // price: productInfo.price,
              // currency: productInfo.currency,
              // quantity: productInfo.quantity
            };
          } else {
            return null;
          }
        }).filter(item => item !== null);
    
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: eventType,
          ecommerce: {
            items: items
          }
        });
      })
      .catch(error => {
        console.error('Error fetching cart data:', error);
      });
    }

  function setupButtonListeners(shadowRoot) {
    // This function will apply listeners to the plus and minus buttons
    const applyListeners = () => {
      const upcartPlusButtons = shadowRoot.querySelectorAll('.upcart-product-quantity-plus');
      const upcartMinusButtons = shadowRoot.querySelectorAll('.upcart-product-quantity-minus');
      const upcartDeleteButons = shadowRoot.querySelectorAll('.styles_TrashButton__deleteButton__8uIHq')
  
      upcartPlusButtons.forEach(button => {
        button.removeEventListener("click", handleAddClick);
        button.addEventListener("click", handleAddClick);
      });
  
      upcartMinusButtons.forEach(button => {
        button.removeEventListener("click", handleRemoveClick);
        button.addEventListener("click", handleRemoveClick);
      });
      
      upcartDeleteButons.forEach(button => {
        button.removeEventListener("click", handleRemoveIconClick);
        button.addEventListener("click", handleRemoveIconClick);
      });
    };
  
    // Set up a mutation observer to monitor changes within the shadow DOM
    const innerObserver = new MutationObserver(() => {
      applyListeners(); // Apply listeners each time there’s a change
    });
  
    // Start observing the shadowRoot for childList changes, which catches re-renders
    innerObserver.observe(shadowRoot, { childList: true, subtree: true });
  
    // Apply listeners initially
    applyListeners();
  }

  function handleAddClick(button) {
    console.log("Add to cart clicked");
    const productLink = this.closest(".upcart-product-item").querySelector(".upcart-product-title-link").getAttribute("href");
    const [path, query] = productLink.split("?");
    const productHandle = path.replace("/products/", "");
    console.log(productHandle);
    const variantId = new URLSearchParams(query).get("variant");
    pushToDataLayer(productHandle, variantId, "add_to_cart", "1");
    }
    
    function handleRemoveClick(button) {
    console.log("Remove from cart clicked");
    const productLink = this.closest(".upcart-product-item").querySelector(".upcart-product-title-link").getAttribute("href");
    const [path, query] = productLink.split("?");
    const productHandle = path.replace("/products/", "");
    console.log(productHandle);
    const variantId = new URLSearchParams(query).get("variant");
    pushToDataLayer(productHandle, variantId, "remove_from_cart", "1");
    }
    
    function handleRemoveIconClick(){
      console.log("Remove from cart clicked");
      let quantity = this.closest(".Stack__item--fill").querySelector(".upcart-product-quantity-input").value;
      const productLink = this.closest(".upcart-product-item").querySelector(".upcart-product-title-link").getAttribute("href");
      const [path, query] = productLink.split("?");
      const productHandle = path.replace("/products/", "");
      console.log(productHandle);
      const variantId = new URLSearchParams(query).get("variant");
      pushToDataLayer(productHandle, variantId, "remove_from_cart", quantity);
    }


  // Function to get a single product by handle
  async function getProductByHandle({ handle }) {
    let queryResult;
    // Assuming this function returns the single product object using the handle
    const query = `query ProductByHandle($handle: String!) {
      productByHandle(handle: $handle) {
        id
        title
        tags
        priceRange {
          maxVariantPrice {
            amount
            currencyCode
          }
          minVariantPrice {
            amount
            currencyCode
          }
        }
        collections(first: 100) {
          edges {
            node {
              title
              description
              handle
            }
          }
        }
        variants(first: 100) {
          edges {
            node {
              id
              title
              availableForSale
              price {
                amount
                currencyCode
              }
              compareAtPrice {
                amount
                currencyCode
              }
              selectedOptions {
                name
                value
              }
              sku
            }
          }
        }
      }
    }`;
    
    const variables = { handle };
    const body = JSON.stringify({ query, variables });
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "b15f92edceff800600df18fe4dc41c5a", // Replace with your actual token
      },
      body: body,
    };
    
    

    try {
      const response = await fetch("https://www.sbtxt.co.il/api/2024-10/graphql.json", options);
      const data = await response.json();
      console.log(data);
      return data?.data?.productByHandle ? [data.data.productByHandle] : [];
    } catch (error) {
      console.error("Fetch error:", error);
    }

    }
  
//     function getItemCategories({ product }) {
//       let item_category1 = 'Unknown';
//       let item_category2 = 'Unknown';
  
//   for (let collection of product.collections.edges) {
//       if (collection.node.title.includes('Swimwear') || collection.node.title.includes('swimwear')) {
//           item_category1 = 'Swimwear';
//           if (product.tags.includes('Category_Top')) {
//               item_category2 = 'bikini tops';
//           } else if (product.tags.includes('Category_Bottom')) {
//               item_category2 = 'bikini bottoms';
//           } else if (product.tags.includes('Category_One Piece')) {
//               item_category2 = 'one pieces';
//           } else if (product.tags.includes('Category_Men_Swimwear')) {
//               item_category2 = 'men’s swimwear';
//           }
//       } else if (collection.node.title.includes('Activewear') || collection.node.title.includes('activewear')) {
//           item_category1 = 'Activewear';
//           if (product.tags.includes('Category_ACTIVE TOP')) {
//               item_category2 = 'tops';
//           } else if (product.tags.includes('Category_LEGGING')) {
//               item_category2 = 'leggings';
//           } else if (product.tags.includes('Category_ONESIE')) {
//               item_category2 = 'onesies';
//           }
//       } else if (collection.node.title.includes('Beachwear') || collection.node.title.includes('beachwear')) {
//           item_category1 = 'Beachwear';
//           if (product.tags.includes('Category_Sarong')) {
//               item_category2 = 'sarongs';
//           } else if (product.tags.includes('Category_Dress')) {
//               item_category2 = 'dresses';
//           } else if (product.tags.includes('Category_Skirt')) {
//               item_category2 = 'beach skirts';
//           } else if (product.tags.includes('Category_Pants')) {
//               item_category2 = 'pants';
//           } else if (product.tags.includes('Category_Cover-Up')) {
//               item_category2 = 'cover-ups';
//           } else if (product.tags.includes('Category_Men_Beachwear')) {
//               item_category2 = 'men’s beachwear';
//           }
//       } else if (collection.node.title.includes('Accessories') || collection.node.title.includes('accessories')) {
//           item_category1 = 'Accessories';
//           if (product.tags.includes('Category_accessories')) {
//               item_category2 = 'active accessories';
//           } else if (product.tags.includes('Category_jewelry')) {
//               item_category2 = 'jewelry';
//           } else if (product.tags.includes('Category_Hats')) {
//               item_category2 = 'hats';
//           } else if (product.tags.includes('Category_Slides')) {
//               item_category2 = 'slides';
//           }
//       }
//   }
//   return {item_category1, item_category2};  
// }

      
      // function calculateDiscountPercentage(price, compareAtPrice) {
      // if (compareAtPrice <= price || compareAtPrice <= 0) {
      //   return 0;
      // }
      
      
      // Matching Liquid's arithmetic
      // const discountAmount = compareAtPrice - price;
      // const discountPercentage = (discountAmount * 100) / compareAtPrice;
      
      // Use Math.floor to round down to the nearest integer, similar to how Liquid rounds
      // return Math.floor(discountPercentage);
      // }
      
  // Function to handle a single product and push it to the dataLayer
  async function pushToDataLayer(handle, variantId, eventype, quantity) {
    try {
      let products = await getProductByHandle({ handle }); // Get the product by handle
      if (products.length) {
        const product = products[0]; 
    const selectedVariant = product.variants.edges.find(
      (edge) => edge.node.id === `gid://shopify/ProductVariant/${variantId}`
    )?.node;
    
    if (!selectedVariant) {
      throw new Error("Variant not found");
    }
        // Extract categories and other product-related properties
        // const { item_category1, item_category2 } = getItemCategories({ product });
    
      //   const discount_percentage = selectedVariant.compareAtPrice?.amount
      // ? calculateDiscountPercentage(selectedVariant.price.amount, selectedVariant.compareAtPrice.amount)
      // : 0;
    
        //Extract selected options (if any)
        // const options = selectedVariant.selectedOptions ? selectedVariant.selectedOptions.reduce((acc, obj) => {
        //   acc[obj.name.toLowerCase()] = obj.value;
        //   return acc;
        // }, {}) : {};
    
        const fullItemId = product.id;
        const itemId = fullItemId.split("/").pop();
        // Build the item object for dataLayer
        const item = {
          // ...options,
          item_name: product.title,
          item_id: itemId, // Parent product ID
          item_variant_id: variantId, // Variant ID
          // item_sku: selectedVariant.sku,
          // item_category: item_category1,
          // item_category2: item_category2,
          // discount_percentage: Math.round(discount_percentage) + "%",
          // stock_status: selectedVariant.availableForSale ? "In stock" : "Out of stock",
          // price: String(selectedVariant.price.amount),
          // currency: selectedVariant.price.currencyCode,
          // quantity: quantity // Assuming quantity is 1 for a single product
        };
    
        // Push the item to the dataLayer
        dataLayer.push({ ecommerce: null }); // Clear existing ecommerce data
        dataLayer.push({
          event: eventype,
          ecommerce: {
            items: [item] // Add the single item to the ecommerce array
          }
        });
      }
    } catch (error) {
      console.error("Error pushing to dataLayer:", error);
    }
    }
  
 // Define event handler functions separately
function handleNextClick(shadowRoot) {
  return function () {
    const selectedSlide = shadowRoot.querySelector(".slide.selected");
    if (selectedSlide) {
      const nextSlide = selectedSlide.nextElementSibling;
      if (nextSlide) {
        const productLinkNext = nextSlide.querySelector(".upcart-upsell-item-image-wrapper a");
        const productHandleNext = productLinkNext.getAttribute('href').replace("/products/", "");
        const variantSelector = nextSlide.querySelector(".upcart-upsell-item-variant-selector");
        const selectedOption = variantSelector.options[variantSelector.selectedIndex];
        const productId = selectedOption ? selectedOption.getAttribute("value") : null;
        pushToDataLayer(productHandleNext, productId, "upcart_upsell_viewed", "1");
      } else {
        console.log("No next slide available");
      }
    } else {
      console.error("Selected slide not found");
    }
  };
}

function handlePrevClick(shadowRoot) {
  return function () {
    const selectedSlide = shadowRoot.querySelector(".slide.selected");
    if (selectedSlide) {
      const prevSlide = selectedSlide.previousElementSibling;
      if (prevSlide) {
        const productLinkPrev = prevSlide.querySelector(".upcart-upsell-item-image-wrapper a");
        const productHandlePrev = productLinkPrev.getAttribute('href').replace("/products/", "");
        const variantSelector = prevSlide.querySelector(".upcart-upsell-item-variant-selector");
        const selectedOption = variantSelector.options[variantSelector.selectedIndex];
        const productId = selectedOption ? selectedOption.getAttribute("value") : null;
        pushToDataLayer(productHandlePrev, productId, "upcart_upsell_viewed", "1");
      } else {
        console.log("No previous slide available");
      }
    } else {
      console.error("Selected slide not found");
    }
  };
}

function handleAddToCartClick(event) {
  const customElement = document.querySelector('#upCart');
  const shadowRoot = customElement.shadowRoot; // Replace with actual shadow root selector if needed
  console.log(shadowRoot);
  const selectedSlide = shadowRoot.querySelector(".slide.selected");
  if (selectedSlide) {
    const productLink = selectedSlide.querySelector(".upcart-upsell-item-image-wrapper a");
    const productHandle = productLink.getAttribute('href').replace("/products/", "");
    const variantSelector = selectedSlide.querySelector(".upcart-upsell-item-variant-selector");
    const selectedOption = variantSelector.options[variantSelector.selectedIndex];
    const productId = selectedOption ? selectedOption.getAttribute("value") : null;

    pushToDataLayer(productHandle, productId, "upcart_upsell_added", "1");
  } else {
    console.error("No selected slide found.");
  }
}


// Setup listeners for carousel buttons and use delegation for Add to Cart
function setupCarouselListeners(shadowRoot) {
  const upsellCarouselNextBtn = shadowRoot.querySelector("button.control-arrow.control-next");
  const upsellCarouselPrevBtn = shadowRoot.querySelector("button.control-arrow.control-prev");

  // Add click listeners for Next and Previous buttons
  upsellCarouselNextBtn?.addEventListener("click", handleNextClick(shadowRoot));
  upsellCarouselPrevBtn?.addEventListener("click", handlePrevClick(shadowRoot));

}
 
  
  // Watch for upCart shadow DOM element to appear
  const observer = new MutationObserver(() => {
  const customElement = document.querySelector('#upCart');
  if (customElement && customElement.shadowRoot) {
    setupButtonListeners(customElement.shadowRoot);
    setupCarouselListeners(customElement.shadowRoot);
    observer.disconnect(); // Stop observing once the element is found
  }
  });

  
  // Start observing the body for changes (to catch dynamically added #upCart)
  observer.observe(document.body, { childList: true, subtree: true });
  
 


